import { j as c } from "../../jsx-runtime-Wav_3Wde.js";
import s from "../BaseIcon.mjs";
const a = (o) => /* @__PURE__ */ c.jsx("svg", {
  viewBox: "0 0 24 24",
  "aria-label": "Closed padlock",
  ...o,
  children: /* @__PURE__ */ c.jsxs("g", {
    children: [
      /* @__PURE__ */ c.jsx("path", {
        d: "M8,9.03c0-0.04,0-2.27,0-2.31c0.07-1.96,2.03-3.72,4-3.72c1.96,0,3.93,1.75,4,3.7c0,0.05,0,2.28,0,2.32h2    c0-0.04,0-2.26,0-2.3C17.94,3.56,15.18,1,12,1C8.83,1,6.08,3.54,6,6.71c0,0.05,0,2.28,0,2.32H8z"
      }),
      /* @__PURE__ */ c.jsx("path", {
        d: "M4,10.95v10.04C4,22.1,4.9,23,6,23h12c1.1,0,2-0.9,2-2.01V10.95H4z M12.74,16.18v4.31h-1.5v-4.31    c-0.45-0.26-0.75-0.74-0.75-1.3c0-0.83,0.67-1.51,1.5-1.51s1.5,0.67,1.5,1.51C13.49,15.44,13.19,15.92,12.74,16.18z"
      })
    ]
  })
}), r = (o) => /* @__PURE__ */ c.jsx(s, {
  IconSvg: a,
  ...o
});
export {
  r as default
};
